// extracted by mini-css-extract-plugin
module.exports = {"user-info":"UserInformation_user-info__W_38M","user-information":"UserInformation_user-information__3y3xV"};